import { DefaultTheme } from 'styled-components';
import {darken, lighten, rgba, setLightness, shade} from "polished";
import palette from "./palette";

const lightTheme: DefaultTheme = {
    colors: {
        bg: "white",
        fg: palette.midnightBlue,
        primaryBg: palette.belizeHole,
        primaryFg: palette.clouds,
        secondaryBg: lighten(.5, palette.belizeHole),
        secondaryFg: palette.midnightBlue,
        cardBg: palette.clouds,
        cardFg: palette.midnightBlue,
        mutedBg: palette.silver,
        mutedFg: palette.asbestos,
        hover: (baseColor: string) => rgba(shade(.4, baseColor), .5),
        even: (baseColor: string) => darken(.025, baseColor),
    },

    dashboard: {
        chartTextColor: palette.clouds,
    },

    accents: {
        default: {
            bg: palette.clouds,
            fg: palette.midnightBlue,
        },

        primary: {
            primaryBg: palette.belizeHole,
            primaryFg: palette.clouds,
            cardBg: palette.belizeHole,
            cardFg: palette.clouds,
        },

        muted: {
            primaryBg: "rgba(0, 0, 0, .12)",
            primaryFg: rgba(palette.midnightBlue, .8),
            cardFg: rgba(palette.midnightBlue, .5),
            cardBg: rgba(palette.clouds, .6),
        },

        info: {
            primaryBg: palette.midnightBlue,
            primaryFg: palette.clouds,
            cardBg: palette.clouds,
            cardFg: palette.midnightBlue,
        },

        danger: {
            primaryBg: palette.alizarin,
            primaryFg: lighten(.5, palette.alizarin),
            cardBg: lighten(.5, palette.alizarin),
            cardFg: palette.alizarin,
        },

        success: {
            primaryBg: darken(.1, palette.nephritis),
            primaryFg: lighten(.5, palette.nephritis),
            cardBg: lighten(.5, palette.nephritis),
            cardFg: darken(.1, palette.nephritis)
        },

        warning: {
            primaryBg: palette.orange,
            primaryFg: lighten(.45, palette.orange),
            cardBg: lighten(.45, palette.orange),
            cardFg: palette.orange,
        }
    },

    bodyClass: "light"
};

export default lightTheme;
